<template>
  <div id="app">
    <div :class="{darkmode: dark}" />
    <AveNav :darkmode="dark"/>
    <AveTimetrack/>
    <!--  Router View renders nested Components in their given path -->
    <!-- Das Heißt, dass man allen Components nun die Prop des darkmodes übergeben kann und diese dann gerendert werden -->
    <transition mode="out-in">
      <router-view class="active-route" :darkmode="dark" :key="$route.path"/>
    </transition>
    <AveToasty
      v-for="toasty in $store.state.toasties"
      :darkmode="dark"
      :action="toasty.action"
      :labelConfirm="toasty.labelConfirm"
      :labelClose="toasty.labelClose"
      :iconConfirm="toasty.iconConfirm"
      :iconClose="toasty.iconClose"
      :key="toasty.id"
      :text="toasty.text"
      @close="$store.commit('closeToasty', toasty.id)"
    />
  </div>
</template>
<script>
import AveNav from '@/components/AveNav.vue';
import AveTimetrack from '@/components/AveTimetrack.vue';
import AveToasty from '@/components/AveToasty.vue';

import { format } from 'date-fns';

import db from '@/db';

export default {
  computed: {
    dark() {
      return this.$store.state.darkmode;
    },
    currentTodoTitle() {
      return this.$store.state.currentTrackingTitle;
    },
    currentTodoTime() {
      return this.$store.state.currentTrackingTime;
    },
    currentTodoTrackedTime() {
      return this.$store.state.currentTrackingTimePassed;
    },
    formatCurrentTodoTrackedTime() {
      return format((this.$store.state.currentTrackingTimePassed), 'HH:mm:ss');
    },
  },
  data() {
    return {
    };
  },
  components: {
    AveNav,
    AveTimetrack,
    AveToasty,
  },
  async created() {
    // install prompt
    window.addEventListener('beforeinstallprompt', (prompt) => {
      prompt.preventDefault();
      this.$store.commit('setInstallPrompt', prompt);
    });
    // Config: hide / show
    // Try
    try {
      const config = await db.config.toArray();
      const configObject = config.reduce((accumulator, configs) => {
        accumulator[configs.name] = configs.value; // eslint-disable-line no-param-reassign
        return accumulator;
      }, {});
      if (configObject.onboardingComplete) this.$store.commit('setOnboardingComplete', true);
      if (configObject.installAsked) this.$store.commit('setInstallAsked', true);
      if (configObject.hideFinishedTodos) this.$store.commit('toggleHideFinishedTodos', configObject.hideFinishedTodos);
      if (configObject.trackingId !== -1 && typeof configObject.trackingId !== 'undefined') {
        // Hier kommt die Resume FUnktuin hin
        // console.log('you Should start Tracking');
        const lastTracked = await db.todos.get(configObject.trackingId);
        console.log(lastTracked);
        const trackingData = {
          trackingTitle: lastTracked.title,
          trackingId: lastTracked.id,
          trackingDoneTime: lastTracked.donetime,
          startTime: lastTracked.startTracking,
          trackingTime: lastTracked.time,
        };
        // console.log(trackingData.trackingDoneTime);
        this.$store.dispatch('startTracking', trackingData);
      }
    } catch (err) {
      console.warn(`Error initializing configs: ${err.message}`);
    }
  },

  watch: {
    async $route(to, from) {
      if (to.name === 'Projects' && from.name === 'Config' && this.$store.state.installPrompt) {
        this.$store.commit('addToasty', {
          action: async () => {
            // // console.log('Test toasties');
            // this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
            // So wird der Installationsdialog aufgerufen
            this.$store.state.installPrompt.prompt();
            this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
            // Die Antwort des Nutzers landet in userChoice, deshalb warten wir darauf
            const choice = await this.$store.state.installPrompt.userChoice;

            if (choice === 'accepted') {
              this.$store.commit('addToasty', {
                action: () => {
                  this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
                },
                labelClose: 'Get started.',
                iconClose: 'done',
                text: 'Nice! Ave should have been added to your homescreen or desktop. You can now launch it from there and close this tab.',
              });
            } else {
              this.$store.commit('addToasty', {
                action: () => {
                  this.$store.commit('closeToasty', this.$store.state.toasties[this.$store.state.toasties.length - 1].id);
                },
                labelClose: 'Close',
                iconClose: 'wrong',
                text: 'That\'s okay. We\'re sorry you don\'t like the app.',
              });
            }
          },
          labelConfirm: 'Install.',
          iconConfirm: 'done',
          labelClose: 'No thanks.',
          iconClose: 'wrong',
          text: 'Would you like to install Ave to your device?',
        });
        await this.$store.dispatch('setInstallAsked', true);
      }
    },

  },
};
</script>
<style lang="stylus">
@require 'assets/styles/colors.styl'
@require 'assets/styles/styles.styl'
#app
  height 100%
  display block

  .active-route
  &.v-enter-active,
  &.v-leave-active
    transition: opacity 100ms ease, transform 500ms ease

    &.v-enter,
    &.v-leave-to
      opacity: 0
      // transform: translateX(-100%)

  .navBG
    position fixed
    bottom 0
    transform: translateX(-50%);
    left 50%
    z-index 2

.darkmode
  position: fixed;
  top:0
  bottom:0
  left:0
  right:0
  background-color: $normal
  z-index: -2
</style>
